"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultTexts = exports.defaultMobileTexts = exports.defaultDesktopTexts = void 0;
const defaultMobileTexts = exports.defaultMobileTexts = {
  subscribeButton: 'Подписаться',
  subscribeDescription: 'Мы будем присылать на почту новые отзывы о жилом комплексе',
  subscribeErrorDescription: 'Попробуйте подписаться ещё раз',
  subscribeErrorTitle: 'Что-то пошло не так...',
  subscribeRetryButton: 'Повторить',
  subscribeSuccessTitle: 'Подписка оформлена!',
  subscribeTitle: 'Подписка на отзывы',
  unsubscribeButton: 'Отписаться',
  unsubscribeErrorDescription: 'Попробуйте отписаться ещё раз',
  unsubscribeErrorTitle: 'Что-то пошло не так...',
  unsubscribeRetryButton: 'Повторить',
  unsubscribeSuccessTitle: 'Вы отписались',
  unsubscribeTitle: 'Отписка от отзывов'
};
const defaultDesktopTexts = exports.defaultDesktopTexts = {
  subscribeButton: 'Подписаться',
  subscribeDescription: 'Мы будем присылать на почту новые отзывы о жилом комплексе',
  subscribeError: 'Что-то пошло не так, попробуйте подписаться ещё раз',
  subscribeRetryButton: 'Повторить',
  subscribeSuccess: 'Подписка оформлена!',
  subscribeTitle: 'Подписка на отзывы',
  unsubscribeButton: 'Отписаться',
  unsubscribeError: 'Что-то пошло не так, попробуйте отписаться ещё раз',
  unsubscribeRetryButton: 'Повторить',
  unsubscribeSuccess: 'Вы отписались от уведомлений о новых отзывах',
  unsubscribeTitle: 'Отписка от отзывов'
};
const defaultTexts = exports.defaultTexts = {
  desktop: defaultDesktopTexts,
  mobile: defaultMobileTexts
};